var getValueFromPosition = function getValueFromPosition(position, min, max, width) {
  var ratio = position / width;
  var result = (max - min) * ratio + min;

  if (result > max) {
    result = max;
  } else if (result < min) {
    result = min;
  }

  return Math.round(result);
};

var getPositionFromValue = function getPositionFromValue(value, min, max, width) {
  var interval = max - min;

  if (interval <= 0) {
    interval = 1;
  }

  var ratio = width / interval;
  var result = value;

  if (result > max) {
    result = max;
  } else if (result < min) {
    result = min;
  }

  result -= min;
  return Math.round(result * ratio);
};

export { getPositionFromValue, getValueFromPosition };